import { CommonModule } from '@angular/common';
import { Component, input, OnInit, output, signal, ViewChild } from '@angular/core';
import { IonDatetime, IonicModule } from '@ionic/angular';
import moment, { Moment } from 'moment';
import { SharedModule } from 'src/app/shared/shared.module';
import { SopoDialogSettings } from 'src/app/sopo-popup/interfaces/dialog';
import { HistoryType, SelectableHistoryType, StatusFilterOptions } from 'src/app/sopo-popup/interfaces/transaction-history-filter';

@Component({
    selector: 'app-transaction-history-filter',
    templateUrl: './transaction-history-filter.component.html',
    styleUrls: ['./transaction-history-filter.component.scss'],
    standalone: true,
    imports: [IonicModule, CommonModule, SharedModule]
})
export class TransactionHistoryFilterComponent implements OnInit {

    public customStartDate = signal<ICustomDate | null>(null);
    public customEndDate = signal<ICustomDate | null>(null);
    public selectedStatus = signal<StatusFilterOptions | null>(null);

    public startDate = signal<Moment | null>(null);
    public endDate = signal<Moment | null>(null);
    public currentDate = moment();

    data = input<any>();
    filterData = output<any>();

    public selectedHistoryType = signal<SelectableHistoryType>("All");
    public historyTypes = ["All", "XP Converted", "Purchase", "Deposit", "Withdraw", "SC Redeem", "Item Purchase", "Side Prediction"];

    @ViewChild('startDateSelector') startDateSelector: IonDatetime;
    @ViewChild('endDateSelector') endtDateSelector: IonDatetime;

    public months = ["January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"];
    public dateFormatOptions = {
        date: {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
        }
    };

    constructor() {}

    ngOnInit(): void {
        if (this.data() && this.data().status != undefined) this.selectedStatus.set(this.data().status);
        if (this.data() && this.data().startDate) {
            this.startDate.set(this.data().startDate);
            this.customStartDate.set(this.getCustomDate(this.data().startDate));
        }
        if (this.data() && this.data().endDate) {
            this.endDate.set(this.data().endDate);
            this.customEndDate.set(this.getCustomDate(this.data().endDate));
        }
        if (this.data() && this.data().historyType) this.selectedHistoryType.set(this.data().historyType);
    }

    public dateChange(event: CustomEvent, type: 'start' | 'end'): void {
        if (!event.detail.value) return;
        const momentObj = moment(event.detail.value);
        const customDate = this.getCustomDate(momentObj);

        if (type == 'start') {
            this.startDate.set(momentObj.startOf('day'));
            this.customStartDate.set(customDate);
            if (momentObj.isAfter(this.endDate())) {
                this.endDate.set(momentObj.endOf('day'));
                this.customEndDate.set(customDate);
            }
        } else {
            this.endDate.set(momentObj.endOf('day'));
            this.customEndDate.set(customDate);
            if (momentObj.isBefore(this.startDate())) {
                this.startDate.set(momentObj.startOf('day'));
                this.customStartDate.set(customDate);
            }
        }
    }

    public onStatusSelect(status: StatusFilterOptions): void {
        this.selectedStatus.set(status);
    }

    public onHistoryTypeSelect(historyType: string): void {
        this.selectedHistoryType.set(historyType as HistoryType);
    }

    public applyFilters(): void {
        this.filterData.emit({
            status: this.selectedStatus(),
            startDate: this.startDate(),
            endDate: this.endDate(),
            historyType: this.selectedHistoryType() === "All" ? null : this.selectedHistoryType()
        });
    }

    public clearFilters(): void {
        this.selectedStatus.set(null);
        this.startDate.set(null);
        this.endDate.set(null);
        this.customStartDate.set(null);
        this.customEndDate.set(null);
        this.startDateSelector?.reset();
        this.endtDateSelector?.reset();
        this.selectedHistoryType.set("All");
        this.applyFilters();
    }

    private getCustomDate(moment: Moment): ICustomDate {
        return {
           month: moment.month(),
            day: moment.date(),
            year: moment.year(),
        };
    }
}



interface ICustomDate {
    month: number;
    day: number;
    year: number;

}

export interface ISopoAccountHistoryFilterSettings extends SopoDialogSettings {
    data: ISopoAccountHistoryFilterData;
}

export interface ISopoAccountHistoryFilterData {
    status: StatusFilterOptions;
    startDate: Date;
    endDate: Date;
}
